import { dispatchSlice } from "./dispatchSlice";
import { useSlice } from "./useSlice";
import { fetchMyAcademics } from "data/actions/myAcademicsActions";

export function useMyAcademics() {
  dispatchSlice(fetchMyAcademics);
  const myAcademics = useSlice("myAcademics");
  return myAcademics;
}
